/**
 * Unidades Zeh Motoca — contatos operacionais (resumo por empresa).
 * Endereço completo: apenas João Pessoa consta no site institucional; demais cidades com base na operação (complementar endereço físico quando disponível).
 */

export type CanalContato = {
  label: string;
  /** ex.: tel:+5584... ou https://wa.me/5584... */
  href: string;
  /** Texto exibido */
  display: string;
};

export type UnidadeZehMotoca = {
  id: 'jp' | 'natal' | 'fortaleza';
  nome: string;
  cidadeUf: string;
  enderecoLinhas: string[];
  canais: {
    emergencia: CanalContato;
    oficina: CanalContato;
    atendimento: CanalContato;
    financeiro: CanalContato;
  };
};

const wa = (digits: string) => `https://wa.me/${digits}`;

export const zehmotocaUnidades: UnidadeZehMotoca[] = [
  {
    id: 'jp',
    nome: 'Zeh Motoca JP',
    cidadeUf: 'João Pessoa — PB',
    enderecoLinhas: [
      'Av. Min. José Américo de Almeida, 601 - Torre',
      'João Pessoa - PB, 58040-300',
    ],
    canais: {
      emergencia: {
        label: 'Emergência',
        href: wa('5584988162009'),
        display: '(84) 98816-2009',
      },
      oficina: {
        label: 'Oficina',
        href: wa('5584988162009'),
        display: '(84) 98816-2009',
      },
      atendimento: {
        label: 'Atendimento',
        href: wa('5584988162009'),
        display: '(84) 98816-2009',
      },
      financeiro: {
        label: 'Financeiro',
        href: wa('5584988162000'),
        display: '(84) 98816-2000',
      },
    },
  },
  {
    id: 'natal',
    nome: 'Zeh Motoca Natal',
    cidadeUf: 'Natal — RN',
    enderecoLinhas: [
      'Unidade Natal — Rio Grande do Norte.',
      'Endereço da loja/oficina: confirme com o atendimento ou financeiro.',
    ],
    canais: {
      emergencia: {
        label: 'Emergência',
        href: 'tel:08002019090',
        display: '0800 201 9090',
      },
      oficina: {
        label: 'Oficina',
        href: wa('5584981312924'),
        display: '(84) 98131-2924',
      },
      atendimento: {
        label: 'Atendimento',
        href: wa('558430263949'),
        display: '(84) 3026-3949',
      },
      financeiro: {
        label: 'Financeiro',
        href: wa('5511911975992'),
        display: '(11) 91197-5992',
      },
    },
  },
  {
    id: 'fortaleza',
    nome: 'Zeh Motoca Fortaleza',
    cidadeUf: 'Fortaleza — CE',
    enderecoLinhas: [
      'Unidade Fortaleza — Ceará.',
      'Endereço da loja/oficina: confirme com o atendimento ou financeiro.',
    ],
    canais: {
      emergencia: {
        label: 'Emergência',
        href: wa('5584981312924'),
        display: '(84) 98131-2924',
      },
      oficina: {
        label: 'Oficina',
        href: wa('5584981312924'),
        display: '(84) 98131-2924',
      },
      atendimento: {
        label: 'Atendimento',
        href: wa('5584981312924'),
        display: '(84) 98131-2924',
      },
      financeiro: {
        label: 'Financeiro',
        href: wa('5584981312929'),
        display: '(84) 98131-2929',
      },
    },
  },
];

const heroSub =
  'Praticidade para quem trabalha na cidade: planos de locação, oficina própria e time que entende a correria do dia a dia.';

/** Hero do site: cidade no título + WhatsApp do atendimento da unidade. */
export const zehmotocaHeroSlides = zehmotocaUnidades.map((u) => {
  const cidade = u.cidadeUf.split(' — ')[0];
  return {
    id: u.id,
    cidade,
    titulo: `${cidade}: liberdade sobre duas rodas com a Zeh Motoca`,
    subtitulo: heroSub,
    whatsappHref: u.canais.atendimento.href,
  };
});
